import React from "react";
import { MetricCard, Panel, StatusBadge } from "../../components/ui/dashboard";

const ReceiverDashboard: React.FC = () => {
  return (
    <div className="p-4 md:p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricCard title="Pending Deliveries" value="14" accent="amber" />
        <MetricCard title="Expected Today" value="6" accent="blue" />
      </div>
      <Panel title="Incoming Deliveries" subtitle="Track and confirm receipt">
        <div className="space-y-2">
          {[
            { lr: "TT-2026-00201", eta: "Today, 5:00 PM", status: "out_for_delivery" },
            { lr: "TT-2026-00202", eta: "Tomorrow, 11:30 AM", status: "in_transit" },
          ].map((item) => (
            <div key={item.lr} className="rounded-xl border border-slate-100 p-3 flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-slate-900">{item.lr}</p>
                <p className="text-xs text-slate-500">ETA: {item.eta}</p>
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge label={item.status} tone="info" />
                <button className="px-2 py-1 rounded-md text-xs bg-emerald-50 text-emerald-700">Confirm Receipt</button>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
};

export default ReceiverDashboard;